import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

import { IncidentIdsGroup } from '../../../configuration'

export const incidentIdsGroup: IncidentIdsGroup = {
  name: 'Substitution',
  incidentIds: [
    RugbyLeagueIncidentId.SubstitutionOut,
    RugbyLeagueIncidentId.SubstitutionIn,
  ],
}
